var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assset-frame-sm"},[_c('h2',[_vm._v(_vm._s(_vm.source.title))]),_c('div',{staticClass:"computer"},[_c('img',{attrs:{"src":`${_vm.vendorURL}plainComputer.png`}}),_c('img',{staticClass:"innerImg",attrs:{"src":`${_vm.vendorURL}vendors/${_vm.vendorName}/image/${_vm.source.src}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }